import cn from 'classnames'
import { throttle } from 'lodash'
import React, { useRef } from 'react'
import { useIsomorphicLayoutEffect } from 'react-use'

import styles from './FixedFooter.module.scss'

function FixedFooter({ children, className, ...props }: React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>) {
  const footerRef = useRef<HTMLDivElement | null>(null)

  useIsomorphicLayoutEffect(() => {
    if (footerRef.current instanceof HTMLElement) {
      footerRef.current.style.transform = `translateX(${window.scrollX * -1}px)`
    }

    const callback = throttle((ev: Event) => {
      if (ev.target === document && footerRef.current instanceof HTMLElement) {
        footerRef.current.style.transform = `translateX(${window.scrollX * -1}px)`
      }
    }, 100)

    window.addEventListener('scroll', callback)

    return () => {
      window.removeEventListener('scroll', callback)
    }
  }, [])

  return (
    <div ref={footerRef} className={cn(styles.root, className)} {...props}>
      {children}
    </div>
  )
}

export default React.memo(FixedFooter)
